/* T8 Product Reviews: star filters, sort (recent / highest / lowest), View More, photo strip scroll */
(function () {
  'use strict';
  function init(root) {
    (root || document).querySelectorAll('[data-t8-reviews]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var list = sec.querySelector('[data-t8-rev-list]');
      var more = sec.querySelector('[data-t8-rev-more]');
      var empty = sec.querySelector('[data-t8-rev-empty]');
      var sort = sec.querySelector('[data-t8-rev-sort]');
      var filters = sec.querySelectorAll('[data-t8-rev-filter]');
      var perPage = Number(sec.dataset.perPage) || 3;
      var expanded = false;

      function items() { return list ? Array.prototype.slice.call(list.querySelectorAll('.t8-rev__item')) : []; }
      function activeStars() { var s = {}; filters.forEach(function (f) { s[f.dataset.t8RevFilter] = f.checked; }); return s; }
      function apply() {
        if (!list) return;
        var stars = activeStars(), mode = sort ? sort.value : 'recent';
        var all = items();
        all.sort(function (a, b) {
          if (mode === 'highest') return Number(b.dataset.rating) - Number(a.dataset.rating) || (b.dataset.date > a.dataset.date ? 1 : -1);
          if (mode === 'lowest') return Number(a.dataset.rating) - Number(b.dataset.rating) || (b.dataset.date > a.dataset.date ? 1 : -1);
          return b.dataset.date > a.dataset.date ? 1 : b.dataset.date < a.dataset.date ? -1 : 0;
        });
        var shown = 0;
        all.forEach(function (el) {
          list.appendChild(el);
          var visible = filters.length ? stars[el.dataset.rating] !== false : true;
          if (visible) { shown++; el.hidden = !expanded && shown > perPage; } else el.hidden = true;
        });
        if (empty) empty.hidden = shown > 0;
        if (more) {
          more.hidden = shown <= perPage;
          if (!more.dataset.more) more.dataset.more = more.textContent.trim();
          more.textContent = expanded ? (more.dataset.less || more.dataset.more) : more.dataset.more;
          more.setAttribute('aria-expanded', String(expanded));
        }
      }
      filters.forEach(function (f) { f.addEventListener('change', apply); });
      if (sort) sort.addEventListener('change', apply);
      if (more) more.addEventListener('click', function () { expanded = !expanded; apply(); if (!expanded && list) list.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      if (list) apply();

      var photos = sec.querySelector('[data-t8-rev-photos]'), pmore = sec.querySelector('[data-t8-rev-photomore]');
      if (photos && pmore) {
        function check() { pmore.hidden = photos.scrollWidth - photos.clientWidth - photos.scrollLeft < 8; }
        pmore.addEventListener('click', function () { photos.scrollBy({ left: 324, behavior: 'smooth' }); });
        photos.addEventListener('scroll', check, { passive: true });
        window.addEventListener('resize', check);
        check();
      }

      /* ---------- dialogs: close button, backdrop click ---------- */
      function wireDialog(d) {
        if (!d) return;
        d.querySelectorAll('[data-t8-rev-close]').forEach(function (b) { b.addEventListener('click', function () { d.close(); }); });
        d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
      }

      /* ---------- photo viewer: any customer photo opens large ---------- */
      var zoom = sec.querySelector('[data-t8-rev-zoombox]'), zimg = zoom && zoom.querySelector('[data-t8-rev-zoomimg]');
      wireDialog(zoom);
      sec.addEventListener('click', function (e) {
        var b = e.target.closest('[data-t8-rev-zoom]'); if (!b || !zoom || !zoom.showModal) return;
        zimg.src = b.dataset.t8RevZoom; zoom.showModal();
      });

      /* ---------- Write a Review: 1 rate · 2 photos / video · 3 write · 4 post → thank you ---------- */
      var wr = sec.querySelector('[data-t8-wr]'), opener = sec.querySelector('[data-t8-rev-write]');
      if (wr && opener && wr.showModal) {
        wireDialog(wr);
        var form = wr.querySelector('form'), steps = wr.querySelectorAll('[data-step]'), dots = wr.querySelectorAll('[data-t8-wr-dots] li');
        var back = wr.querySelector('[data-t8-wr-back]'), next = wr.querySelector('[data-t8-wr-next]'), skip = wr.querySelector('[data-t8-wr-skip]');
        var nav = wr.querySelector('[data-t8-wr-nav]'), err = wr.querySelector('[data-t8-wr-err]');
        var stars = wr.querySelectorAll('[data-t8-wr-star]'), rateLabel = wr.querySelector('[data-t8-wr-ratelabel]');
        var titleIn = wr.querySelector('[data-t8-wr-titlein]'), textIn = wr.querySelector('[data-t8-wr-text]');
        var nameIn = wr.querySelector('[data-t8-wr-name]'), emailIn = wr.querySelector('[data-t8-wr-email]');
        var previews = wr.querySelector('[data-t8-wr-previews]'), waBtn = wr.querySelector('[data-t8-wr-wa]');
        var WORDS = ['', 'Poor', 'Fair', 'Good', 'Very good', 'Love it!'];
        var step = 1, rating = 0, files = [];

        function valid() {
          if (step === 1) return rating > 0;
          if (step === 3) return textIn.value.trim().length >= 10;
          if (step === 4) return nameIn.value.trim().length > 1 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailIn.value.trim());
          return true;
        }
        function show(n) {
          step = n;
          steps.forEach(function (s) { s.hidden = Number(s.dataset.step) !== n; });
          dots.forEach(function (d, i) { d.classList.toggle('is-on', i < n); });
          back.hidden = n === 1 || n === 5; nav.hidden = n === 5; err.hidden = true;
          skip.hidden = !(n === 2 && files.length === 0);
          next.textContent = n === 4 ? 'Post Review' : 'Next';
          next.disabled = !valid();
          var f = steps[n - 1] && steps[n - 1].querySelector('input:not([type="file"]), textarea');
          if (f && n > 2) setTimeout(function () { f.focus(); }, 50);
        }
        stars.forEach(function (b) {
          b.addEventListener('click', function () {
            rating = Number(b.dataset.t8WrStar);
            stars.forEach(function (s) { var on = Number(s.dataset.t8WrStar) <= rating; s.classList.toggle('is-lit', on); s.setAttribute('aria-checked', String(Number(s.dataset.t8WrStar) === rating)); });
            rateLabel.textContent = WORDS[rating];
            next.disabled = false;
            setTimeout(function () { if (step === 1) show(2); }, 450);   // a tap on a star moves on by itself
          });
        });
        function paintPreviews() {
          previews.innerHTML = '';
          files.forEach(function (f, i) {
            var li = document.createElement('li'), url = URL.createObjectURL(f);
            li.innerHTML = (f.type.indexOf('video') === 0 ? '<video muted playsinline src="' + url + '"></video>' : '<img alt="" src="' + url + '">') + '<button type="button" aria-label="Remove">×</button>';
            li.querySelector('button').addEventListener('click', function () { files.splice(i, 1); paintPreviews(); });
            previews.appendChild(li);
          });
          skip.hidden = !(step === 2 && files.length === 0);
        }
        wr.querySelectorAll('[data-t8-wr-file]').forEach(function (inp) {
          inp.addEventListener('change', function () {
            Array.prototype.forEach.call(inp.files || [], function (f) { if (files.length < 6) files.push(f); });
            inp.value = ''; paintPreviews();
          });
        });
        [titleIn, textIn, nameIn, emailIn].forEach(function (el) { el.addEventListener('input', function () { next.disabled = !valid(); }); });
        back.addEventListener('click', function () { show(Math.max(1, step - 1)); });
        skip.addEventListener('click', function () { show(3); });
        next.addEventListener('click', function () {
          if (!valid()) return;
          if (step < 4) { show(step + 1); return; }
          // post: the review goes to the store's contact email (photos / videos are offered on WhatsApp after)
          var body = 'Rating: ' + rating + ' / 5\n' + (titleIn.value.trim() ? 'Title: ' + titleIn.value.trim() + '\n' : '') + '\n' + textIn.value.trim() +
            (files.length ? '\n\nThe customer added ' + files.length + ' photo / video file(s); asked to send them on WhatsApp.' : '');
          form.querySelector('[data-t8-wr-body]').value = body;
          next.disabled = true; next.textContent = 'Posting…';
          // a real submit, not fetch: Shopify's hCaptcha only adds its token on the submit event (a fetch post gets 403).
          // The page reloads with ?contact_posted=true and the thank-you step reopens from the note left here.
          try { sessionStorage.setItem('t8-wr-sent', JSON.stringify({ path: location.pathname, files: files.length })); } catch (e) {}
          wr.close();   // the modal dialog would sit above the captcha challenge
          if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })) && form.submit();
          setTimeout(function () { next.disabled = false; next.textContent = 'Post Review'; }, 4000);   // captcha closed without passing: let them try again
        });
        // back from the post: show the thank-you step
        var sent = null;
        try { sent = JSON.parse(sessionStorage.getItem('t8-wr-sent') || 'null'); } catch (e) {}
        if (sent && sent.path === location.pathname && /contact_posted=true/.test(location.search + location.hash)) {
          try { sessionStorage.removeItem('t8-wr-sent'); } catch (e) {}
          if (waBtn) waBtn.hidden = !sent.files;
          show(5); wr.showModal();
        }
        opener.addEventListener('click', function () {
          if (step === 5) { rating = 0; files = []; paintPreviews(); form.reset(); stars.forEach(function (s) { s.classList.remove('is-lit'); s.setAttribute('aria-checked', 'false'); }); rateLabel.textContent = 'Tap a star'; }
          show(step === 5 ? 1 : step); wr.showModal();
        });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
